(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-all-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__smAllRevBound) return;
      root.__smAllRevBound = true;

      var token = root.getAttribute('data-token');
      var shop = root.getAttribute('data-shop');
      var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 30;
      var listEl = root.querySelector('[data-sm-jr-list]');
      var moreBtn = root.querySelector('[data-sm-jr-more]');
      var avgEl = root.querySelector('[data-sm-jr-avg]');
      var countEl = root.querySelector('[data-sm-jr-count]');
      var barsEl = root.querySelector('[data-sm-jr-bars]');
      var page = 1, totalShown = 0, totalCount = 0, summaryDone = false;

      function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += '<span class="' + (i <= n ? '' : 'off') + '">★</span>'; return s; }
      function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
      function initials(name) { var p = (name || 'A').trim().split(/\s+/).filter(Boolean); var f = (p[0] || 'A').charAt(0); var l = p.length > 1 ? p[p.length - 1].charAt(0) : ''; return (f + l).toUpperCase(); }
      function fmtDate(raw) { if (!raw) return ''; var d = new Date(raw.replace(' UTC', 'Z').replace(' ', 'T')); return isNaN(d) ? '' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' }); }

      function parse(headerHtml, bodyHtml) {
        var doc = new DOMParser();
        var hdr = doc.parseFromString(headerHtml || '', 'text/html');
        var h = hdr.querySelector('[data-number-of-reviews]');
        var out = { avg: h ? h.getAttribute('data-average-rating') : '0', count: h ? parseInt(h.getAttribute('data-number-of-reviews'), 10) || 0 : 0, hist: {}, revs: [] };
        hdr.querySelectorAll('.jdgm-histogram__row').forEach(function (row) {
          out.hist[row.getAttribute('data-rating')] = { freq: parseInt(row.getAttribute('data-frequency'), 10) || 0, pct: parseInt(row.getAttribute('data-percentage'), 10) || 0 };
        });
        var body = doc.parseFromString(bodyHtml || '', 'text/html');
        body.querySelectorAll('.jdgm-rev').forEach(function (el) {
          var rEl = el.querySelector('.jdgm-rev__rating');
          var ts = el.querySelector('.jdgm-rev__timestamp');
          var pics = [];
          el.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link, .jdgm-rev__pics a').forEach(function (a) {
            var full = a.getAttribute('href') || a.getAttribute('data-mfp-src');
            var im = a.querySelector('img');
            var thumb = im ? (im.getAttribute('data-src') || im.getAttribute('src')) : null;
            if (full || thumb) pics.push({ full: full || thumb, thumb: thumb || full });
          });
          if (!pics.length) {
            el.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pic-img').forEach(function (img) {
              var src = img.getAttribute('data-src') || img.getAttribute('src'); if (src) pics.push({ full: src, thumb: src });
            });
          }
          out.revs.push({
            rating: rEl ? parseInt(rEl.getAttribute('data-score'), 10) || 0 : 0,
            author: ((el.querySelector('.jdgm-rev__author') || {}).textContent || 'Anonymous').trim(),
            verified: el.getAttribute('data-verified-buyer') === 'true',
            title: ((el.querySelector('.jdgm-rev__title') || {}).textContent || '').trim(),
            body: ((el.querySelector('.jdgm-rev__body') || {}).textContent || '').trim(),
            date: ts ? (ts.getAttribute('data-content') || '') : '',
            product: el.getAttribute('data-product-title') || '',
            pics: pics
          });
        });
        return out;
      }

      function renderSummary(data) {
        if (avgEl) avgEl.textContent = parseFloat(data.avg || 0).toFixed(1);
        if (countEl) countEl.textContent = data.count;
        totalCount = data.count;
        var html = '';
        for (var r = 5; r >= 1; r--) {
          var row = data.hist[r] || { freq: 0, pct: 0 };
          html += '<div class="sm-jr__bar"><span class="sm-jr__bar-stars">' + r + ' ★</span><span class="sm-jr__bar-track"><span class="sm-jr__bar-fill" data-pct="' + row.pct + '"></span></span><span class="sm-jr__bar-count">' + row.freq + '</span></div>';
        }
        if (barsEl) {
          barsEl.innerHTML = html;
          requestAnimationFrame(function () { barsEl.querySelectorAll('.sm-jr__bar-fill').forEach(function (f) { f.style.width = (f.getAttribute('data-pct') || 0) + '%'; }); });
        }
      }

      function picsHTML(rv) {
        var arr = rv.pics || [];
        if (!arr.length) return '';
        var gal = JSON.stringify(arr.map(function (p) { return p.full; })).replace(/"/g, '&quot;');
        var meta = JSON.stringify({ name: rv.author, date: rv.date, rating: rv.rating, verified: rv.verified, body: rv.body }).replace(/"/g, '&quot;');
        var max = 4, shown = arr.slice(0, max), extra = arr.length - max;
        var thumbs = shown.map(function (p, i) {
          var more = (i === max - 1 && extra > 0) ? '<span class="sm-jr__card-pic-more">+' + extra + '</span>' : '';
          return '<button type="button" class="sm-jr__card-pic" data-sm-rev-pic data-index="' + i + '" aria-label="View review photo"><img src="' + p.thumb + '" alt="" loading="lazy">' + more + '</button>';
        }).join('');
        return '<div class="sm-jr__card-pics" data-sm-rev-gallery="' + gal + '" data-sm-rev-meta="' + meta + '">' + thumbs + '</div>';
      }
      function cardHTML(rv) {
        var initial = initials(rv.author);
        var verified = rv.verified ? '<span class="sm-jr__verified"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Verified Buyer</span>' : '';
        var title = rv.title ? '<p class="sm-jr__card-title">' + esc(rv.title) + '</p>' : '';
        var prod = rv.product ? '<span class="sm-jr__card-prod">' + esc(rv.product) + '</span>' : '';
        return '<article class="sm-jr__card">' +
          '<div class="sm-jr__card-foot"><span class="sm-jr__card-avatar">' + esc(initial) + '</span>' +
          '<span class="sm-jr__card-meta"><span class="sm-jr__card-author">' + esc(rv.author) + '</span>' +
          (rv.date ? '<span class="sm-jr__card-date">' + fmtDate(rv.date) + '</span>' : '') + '</span>' + verified + '</div>' +
          '<div class="sm-jr__card-top"><span class="sm-jr__stars">' + stars(rv.rating) + '</span></div>' +
          title + '<p class="sm-jr__card-body">' + esc(rv.body) + '</p>' + picsHTML(rv) +
          (prod ? '<div class="sm-jr__card-prodrow">' + prod + '</div>' : '') +
          '</article>';
      }

      function load(append) {
        var url = 'https://judge.me/api/v1/widgets/all_reviews_page?api_token=' + encodeURIComponent(token) + '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&per_page=' + perPage + '&page=' + page;
        if (moreBtn) moreBtn.classList.toggle('is-loading', append);
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var data = parse(d.all_reviews_header, d.all_reviews);
            if (!summaryDone) { renderSummary(data); summaryDone = true; }
            if (!append) listEl.innerHTML = '';
            if (!data.revs.length && !append) { listEl.innerHTML = '<div class="sm-jr__empty">No reviews yet.</div>'; }
            data.revs.forEach(function (rv, i) {
              var div = document.createElement('div'); div.innerHTML = cardHTML(rv);
              var card = div.firstChild; card.style.animationDelay = (Math.min(i, 12) * 0.04) + 's'; listEl.appendChild(card);
            });
            totalShown += data.revs.length;
            if (moreBtn) { moreBtn.classList.remove('is-loading'); moreBtn.hidden = totalShown >= totalCount || data.revs.length === 0; }
          })
          .catch(function () { if (!append) listEl.innerHTML = '<div class="sm-jr__empty">Couldn’t load reviews right now.</div>'; if (moreBtn) moreBtn.classList.remove('is-loading'); });
      }

      load(false);
      if (moreBtn) moreBtn.addEventListener('click', function () { page += 1; load(true); });
    }
    document.querySelectorAll('[data-sm-all-reviews]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-sm-all-reviews]'); if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-authenticity"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__smCertInit) return;
    window.__smCertInit = true;

    var X_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
    var L_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>';
    var R_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>';

    var modal, mImg, mName, certs = [], curIdx = 0;

    function buildModal() {
      if (modal) return;
      modal = document.createElement('div');
      modal.className = 'sm-auth__cert-modal';
      modal.innerHTML =
        '<div class="sm-auth__cert-modal-backdrop" data-sm-cert-close></div>' +
        '<div class="sm-auth__cert-modal-box">' +
          '<button type="button" class="sm-auth__cert-modal-close" data-sm-cert-close aria-label="Close">' + X_SVG + '</button>' +
          '<button type="button" class="sm-auth__cert-modal-nav sm-auth__cert-modal-nav--prev" data-sm-cert-mprev aria-label="Previous">' + L_SVG + '</button>' +
          '<img class="sm-auth__cert-modal-img" alt="">' +
          '<button type="button" class="sm-auth__cert-modal-nav sm-auth__cert-modal-nav--next" data-sm-cert-mnext aria-label="Next">' + R_SVG + '</button>' +
          '<div class="sm-auth__cert-modal-name"></div>' +
        '</div>';
      document.body.appendChild(modal);
      mImg = modal.querySelector('.sm-auth__cert-modal-img');
      mName = modal.querySelector('.sm-auth__cert-modal-name');
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-sm-cert-close]')) { closeModal(); }
        else if (e.target.closest('[data-sm-cert-mprev]')) { showCert(curIdx - 1); }
        else if (e.target.closest('[data-sm-cert-mnext]')) { showCert(curIdx + 1); }
      });
    }

    function collectCerts(track) {
      certs = [];
      track.querySelectorAll('.sm-auth__cert-card').forEach(function (c) {
        certs.push({ url: c.getAttribute('data-sm-cert-url'), brand: c.getAttribute('data-sm-cert-brand') });
      });
    }

    function showCert(i) {
      if (!certs.length) return;
      curIdx = (i + certs.length) % certs.length;
      mImg.src = certs[curIdx].url;
      mImg.alt = certs[curIdx].brand + ' authorization certificate';
      mName.textContent = certs[curIdx].brand;
    }

    function openModal() {
      buildModal();
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    // Arrow scrolling
    document.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-sm-cert-prev]');
      var next = e.target.closest('[data-sm-cert-next]');
      if (!prev && !next) return;
      var carousel = (prev || next).closest('.sm-auth__cert-carousel');
      var track = carousel && carousel.querySelector('[data-sm-cert-track]');
      if (!track) return;
      var card = track.querySelector('.sm-auth__cert-card');
      var step = card ? card.offsetWidth + 18 : 320;
      track.scrollBy({ left: next ? step : -step, behavior: 'smooth' });
    });

    // Open modal on card click
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.sm-auth__cert-card');
      if (!card) return;
      var track = card.closest('[data-sm-cert-track]');
      if (!track) return;
      collectCerts(track);
      var idx = Array.prototype.indexOf.call(track.querySelectorAll('.sm-auth__cert-card'), card);
      openModal();
      showCert(idx);
    });

    // Keyboard: open card with Enter/Space, navigate/close modal
    document.addEventListener('keydown', function (e) {
      if (modal && modal.classList.contains('is-open')) {
        if (e.key === 'Escape') { closeModal(); }
        else if (e.key === 'ArrowLeft') { showCert(curIdx - 1); }
        else if (e.key === 'ArrowRight') { showCert(curIdx + 1); }
        return;
      }
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest && e.target.closest('.sm-auth__cert-card');
        if (card) { e.preventDefault(); card.click(); }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sm-fcoll-tabs')) {
    class SmFcollTabs extends HTMLElement {
      connectedCallback() {
        this._pills = Array.from(this.querySelectorAll('[data-sm-fcoll-tab]'));
        this._panels = Array.from(this.querySelectorAll('[data-sm-fcoll-panel]'));
        this._pills.forEach((pill) => {
          pill.addEventListener('click', (e) => {
            e.preventDefault();
            this._activate(pill.dataset.smFcollTab);
          });
        });
      }
      _activate(idx) {
        this._pills.forEach((p) => {
          var on = p.dataset.smFcollTab === idx;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this._panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.smFcollPanel === idx);
        });
      }
    }
    customElements.define('sm-fcoll-tabs', SmFcollTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-header"]) return;
  try {
    
  (function () {
    if (window.__smHeaderSearchBound) return;
    window.__smHeaderSearchBound = true;

    var overlay = document.querySelector('[data-sm-search-overlay]');
    if (!overlay) return;
    var input = overlay.querySelector('[data-sm-search-input]');
    var micBtn = overlay.querySelector('[data-sm-mic-trigger]');

    function openSearch() {
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('sm-search-open');
      setTimeout(function () { input && input.focus(); }, 80);
    }

    function closeSearch() {
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('sm-search-open');
      stopListening();
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sm-search-trigger]')) {
        e.preventDefault();
        openSearch();
        return;
      }
      if (e.target.closest('[data-sm-search-close]')) {
        e.preventDefault();
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('sm-search-open')) {
        closeSearch();
      }
    });

    /* ── Voice search via Web Speech API ──────────────── */
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    var recog = null;
    var listening = false;

    if (!SR) {
      // Browser doesn't support — hide the mic button
      if (micBtn) micBtn.style.display = 'none';
      var headerMic = document.querySelector('.sm-header__search-mic');
      if (headerMic) headerMic.style.display = 'none';
      return;
    }

    function ensureRecog() {
      if (recog) return recog;
      recog = new SR();
      recog.lang = (document.documentElement.lang || 'en-US').replace('_', '-');
      recog.continuous = false;
      recog.interimResults = true;
      recog.maxAlternatives = 1;

      recog.onresult = function (e) {
        var finalText = '';
        var interimText = '';
        for (var i = e.resultIndex; i < e.results.length; i++) {
          var t = e.results[i][0].transcript;
          if (e.results[i].isFinal) finalText += t;
          else interimText += t;
        }
        var combined = (finalText + interimText).trim();
        if (input) {
          input.value = combined;
          // Trigger any input-listeners (predictive search etc.)
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (finalText.trim() && input && input.form) {
          stopListening();
          // Brief pause so user sees the transcript before submit
          setTimeout(function () { input.form.submit(); }, 400);
        }
      };

      recog.onerror = function () { stopListening(); };
      recog.onend = function () { stopListening(); };
      return recog;
    }

    function startListening() {
      var r = ensureRecog();
      if (!r) return;
      try {
        r.start();
        listening = true;
        if (micBtn) micBtn.classList.add('is-listening');
      } catch (err) {
        // Already started or permission denied — stop and reset
        stopListening();
      }
    }

    function stopListening() {
      if (recog && listening) {
        try { recog.stop(); } catch (e) {}
      }
      listening = false;
      if (micBtn) micBtn.classList.remove('is-listening');
    }

    if (micBtn) {
      micBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (listening) {
          stopListening();
        } else {
          startListening();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__smHeroBound) return;
    window.__smHeroBound = true;

    // Banner slider
    document.querySelectorAll('[data-sm-banner]').forEach(function (root) {
      var track = root.querySelector('[data-sm-banner-track]');
      var slides = root.querySelectorAll('.sm-banner__slide');
      var dots = root.querySelectorAll('[data-sm-banner-dot]');
      if (!track || slides.length < 2) return;
      var current = 0;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      var timer = null;

      function goTo(i) {
        current = ((i % slides.length) + slides.length) % slides.length;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === current); });
      }
      function start() { if (autoplay) timer = setInterval(function () { goTo(current + 1); }, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { stop(); start(); }

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { goTo(i); restart(); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      var startX = null;
      root.addEventListener('touchstart', function (e) {
        if (!e.touches[0]) return;
        startX = e.touches[0].clientX;
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) < 40) return;
        goTo(current + (dx > 0 ? -1 : 1));
        restart();
      }, { passive: true });

      start();
    });

    function setSlide(carousel, idx) {
      var slides = carousel.querySelectorAll('.sm-hero__slide');
      var dots = carousel.querySelectorAll('.sm-hero__dot');
      if (!slides.length) return;
      idx = ((idx % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      carousel.dataset.smCurrent = idx;
    }

    function nextSlide(carousel) {
      var current = parseInt(carousel.dataset.smCurrent || '0', 10);
      setSlide(carousel, current + 1);
    }

    document.querySelectorAll('[data-sm-hero-carousel]').forEach(function (carousel) {
      carousel.dataset.smCurrent = '0';

      carousel.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-sm-dot]');
        if (!dot) return;
        var idx = parseInt(dot.getAttribute('data-sm-dot'), 10);
        setSlide(carousel, idx);
        // Reset autoplay timer
        if (carousel.__smTimer) {
          clearInterval(carousel.__smTimer);
          startAutoplay(carousel);
        }
      });

      function startAutoplay(c) {
        if (c.dataset.autoplay !== 'true') return;
        var interval = parseInt(c.dataset.interval, 10) || 5000;
        var slides = c.querySelectorAll('.sm-hero__slide');
        if (slides.length <= 1) return;
        c.__smTimer = setInterval(function () { nextSlide(c); }, interval);
      }

      carousel.addEventListener('mouseenter', function () {
        if (carousel.__smTimer) clearInterval(carousel.__smTimer);
      });
      carousel.addEventListener('mouseleave', function () {
        startAutoplay(carousel);
      });

      // Touch swipe
      var touchStartX = 0;
      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      carousel.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) < 40) return;
        var current = parseInt(carousel.dataset.smCurrent || '0', 10);
        setSlide(carousel, current + (dx < 0 ? 1 : -1));
        if (carousel.__smTimer) {
          clearInterval(carousel.__smTimer);
          startAutoplay(carousel);
        }
      }, { passive: true });

      startAutoplay(carousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-main-collection"]) return;
  try {
    
  (function () {
    if (window.__smSortBound) return;
    window.__smSortBound = true;
    document.addEventListener('change', function (e) {
      var select = e.target.closest('[data-sm-sort-form] select');
      if (!select) return;
      var form = select.closest('form');
      if (form) form.submit();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__smPdpBound) return;
    window.__smPdpBound = true;

    // Sticky add-to-cart — hide once footer payment row enters viewport
    function smInitStickyHide() {
      var sticky = document.querySelector('.sm-pdp__sticky');
      var footerPay = document.querySelector('.sm-footer__pay');
      if (!sticky || !footerPay || !('IntersectionObserver' in window)) return;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sticky.setAttribute('hidden', '');
          } else {
            sticky.removeAttribute('hidden');
          }
        });
      }, { rootMargin: '0px 0px 0px 0px', threshold: 0 });
      observer.observe(footerPay);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', smInitStickyHide);
    } else {
      smInitStickyHide();
    }

    // Authenticity badge — place each letter on the arc (radius from CSS var)
    function smBuildAuthRing(ring) {
      var text = ring.getAttribute('data-text') || '';
      if (!text) return;
      var badge = ring.closest('.sm-pdp__auth-badge');
      if (!badge) return;
      var radius = parseFloat(getComputedStyle(badge).getPropertyValue('--auth-radius')) || 21;
      var isBot = ring.classList.contains('sm-pdp__auth-ring--bot');
      var step = isBot ? 13.5 : 11.5;
      var mid = (text.length - 1) / 2;
      var html = '';
      for (var i = 0; i < text.length; i++) {
        var angle = (i - mid) * step;
        var transform = isBot
          ? 'translate(-50%, -50%) rotate(' + (180 - angle) + 'deg) translateY(-' + radius + 'px) rotate(180deg)'
          : 'translate(-50%, -50%) rotate(' + angle + 'deg) translateY(-' + radius + 'px)';
        html += '<span style="transform:' + transform + '">' + text.charAt(i) + '</span>';
      }
      ring.innerHTML = html;
    }
    function smBuildAllAuthRings() {
      document.querySelectorAll('.sm-pdp__auth-ring').forEach(smBuildAuthRing);
    }
    smBuildAllAuthRings();
    window.addEventListener('resize', smBuildAllAuthRings);
    window.addEventListener('load', smBuildAllAuthRings);

    // Gallery — shared helper to switch active media + thumb
    function smSetActiveMedia(gallery, mediaId) {
      if (!gallery || !mediaId) return;
      gallery.querySelectorAll('.sm-pdp__media').forEach(function (m) {
        m.classList.toggle('is-active', m.getAttribute('data-sm-media-id') === mediaId);
      });
      var matchedThumb = null;
      gallery.querySelectorAll('.sm-pdp__thumb').forEach(function (t) {
        var match = t.getAttribute('data-sm-thumb-target') === mediaId;
        t.classList.toggle('is-active', match);
        if (match) matchedThumb = t;
      });
      if (matchedThumb && typeof matchedThumb.scrollIntoView === 'function') {
        matchedThumb.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
      }
    }

    // Gallery — thumbnail click switches main image
    document.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-sm-thumb-target]');
      if (!thumb) return;
      var gallery = thumb.closest('[data-sm-gallery]');
      if (!gallery) return;
      smSetActiveMedia(gallery, thumb.getAttribute('data-sm-thumb-target'));
    });

    // Gallery — prev/next arrows on main image
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-main-nav]');
      if (!btn) return;
      var gallery = btn.closest('[data-sm-gallery]');
      if (!gallery) return;
      var medias = Array.prototype.slice.call(gallery.querySelectorAll('.sm-pdp__media'));
      if (medias.length < 2) return;
      var currentIdx = -1;
      for (var i = 0; i < medias.length; i++) {
        if (medias[i].classList.contains('is-active')) { currentIdx = i; break; }
      }
      if (currentIdx < 0) currentIdx = 0;
      var dir = parseInt(btn.getAttribute('data-sm-main-nav'), 10) || 1;
      var nextIdx = (currentIdx + dir + medias.length) % medias.length;
      smSetActiveMedia(gallery, medias[nextIdx].getAttribute('data-sm-media-id'));
    });

    // Gallery — touch swipe on main image
    document.querySelectorAll('[data-sm-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('.sm-pdp__gallery-main');
      if (!main) return;
      var startX = null;
      var startY = null;
      main.addEventListener('touchstart', function (ev) {
        if (!ev.touches[0]) return;
        startX = ev.touches[0].clientX;
        startY = ev.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (ev) {
        if (startX === null || !ev.changedTouches[0]) return;
        var dx = ev.changedTouches[0].clientX - startX;
        var dy = ev.changedTouches[0].clientY - startY;
        startX = null; startY = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var medias = Array.prototype.slice.call(gallery.querySelectorAll('.sm-pdp__media'));
        if (medias.length < 2) return;
        var currentIdx = -1;
        for (var i = 0; i < medias.length; i++) {
          if (medias[i].classList.contains('is-active')) { currentIdx = i; break; }
        }
        if (currentIdx < 0) currentIdx = 0;
        var dir = dx > 0 ? -1 : 1;
        var nextIdx = (currentIdx + dir + medias.length) % medias.length;
        smSetActiveMedia(gallery, medias[nextIdx].getAttribute('data-sm-media-id'));
      }, { passive: true });
    });

    // Gallery — prev/next arrows scroll the thumb track
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-thumb-scroll]');
      if (!btn) return;
      var wrap = btn.closest('.sm-pdp__thumbs-wrap');
      if (!wrap) return;
      var track = wrap.querySelector('[data-sm-thumbs-track]');
      if (!track) return;
      var dir = parseInt(btn.getAttribute('data-sm-thumb-scroll'), 10) || 1;
      var firstThumb = track.querySelector('.sm-pdp__thumb');
      var step = firstThumb ? (firstThumb.offsetWidth + 12) * 3 : 240;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    });

    // Gallery — auto-hide arrows at scroll edges
    function updateThumbArrows(track) {
      var wrap = track.closest('.sm-pdp__thumbs-wrap');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-sm-thumb-scroll="-1"]');
      var next = wrap.querySelector('[data-sm-thumb-scroll="1"]');
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      var noOverflow = track.scrollWidth <= track.clientWidth + 4;
      if (prev) prev.hidden = atStart || noOverflow;
      if (next) next.hidden = atEnd || noOverflow;
    }

    document.querySelectorAll('[data-sm-thumbs-track]').forEach(function (track) {
      updateThumbArrows(track);
      track.addEventListener('scroll', function () { updateThumbArrows(track); });
    });

    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-sm-thumbs-track]').forEach(updateThumbArrows);
    });

    // Bundle & Save — radio change updates active card, label, and qty input
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-sm-bundle-input]');
      if (!input) return;
      var section = input.closest('.sm-pdp');
      if (!section) return;

      section.querySelectorAll('.sm-pdp__bundle').forEach(function (card) {
        var radio = card.querySelector('[data-sm-bundle-input]');
        card.classList.toggle('is-active', radio === input);
      });

      var labelEl = section.querySelector('[data-sm-bundle-label]');
      if (labelEl) {
        labelEl.textContent = input.getAttribute('data-sm-bundle-label-text') || labelEl.textContent;
      }

      var qtyInput = section.querySelector('.sm-pdp__qty-input');
      if (qtyInput) {
        var qty = parseInt(input.value, 10) || 1;
        qtyInput.value = qty;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    // Quantity stepper
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-qty]');
      if (!btn) return;
      var step = parseInt(btn.getAttribute('data-sm-qty'), 10);
      var input = btn.parentElement.querySelector('.sm-pdp__qty-input');
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val = Math.max(1, val + step);
      input.value = val;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // ── Helpers ────────────────────────────────────────────────────────
    function getSection() {
      return document.querySelector('.sm-pdp');
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(amount);
      } catch (e) {
        return '₹' + amount;
      }
    }

    function getVariantsData(section) {
      var script = section && section.querySelector('[data-sm-variants]');
      if (!script) return [];
      try { return JSON.parse(script.textContent); } catch (e) { return []; }
    }

    function findVariantById(variants, id) {
      id = parseInt(id, 10);
      return variants.find(function (v) { return v.id === id; });
    }

    function applyVariantToUI(variant) {
      if (!variant) return;
      var section = getSection();
      if (!section) return;

      // Sync the hidden form id
      var idInput = section.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.id;

      // URL
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}

      // Main price block
      var priceEl = section.querySelector('.sm-pdp__price');
      var mrpEl = section.querySelector('.sm-pdp__mrp');
      var discountEl = section.querySelector('.sm-pdp__discount');
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (mrpEl) {
          mrpEl.textContent = formatMoney(variant.compare_at_price);
          mrpEl.hidden = false;
        }
        if (discountEl) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          discountEl.textContent = 'SAVE ' + pct + '%';
          discountEl.hidden = false;
        }
      } else {
        if (mrpEl) mrpEl.hidden = true;
        if (discountEl) discountEl.hidden = true;
      }

      // Sticky bar — image, name, price, mrp
      var stickyImg = section.querySelector('[data-sm-sticky-image]') || document.querySelector('[data-sm-sticky-image]');
      if (stickyImg && variant.featured_image && variant.featured_image.src) {
        var src = variant.featured_image.src.replace(/\.(jpg|jpeg|png|webp|gif)/i, '_120x.$1');
        stickyImg.src = src;
      }
      var stickyPrice = document.querySelector('[data-sm-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var stickyVariant = document.querySelector('[data-sm-sticky-variant]');
      if (stickyVariant && stickyVariant.value !== String(variant.id)) {
        stickyVariant.value = variant.id;
      }

      // Availability — toggle disabled on every CTA + flip Add to Cart / Sold out text
      document.querySelectorAll('.sm-pdp__add, .sm-pdp__buy, .sm-pdp__sticky-add').forEach(function (btn) {
        btn.disabled = !variant.available;
        if (btn.classList.contains('sm-pdp__buy')) return; // Buy Now keeps its own label
        var textEl = btn.querySelector('.sm-pdp__btn-text');
        if (textEl) textEl.textContent = variant.available ? 'Add to Cart' : 'Sold out';
      });
    }

    // ── Variant picker (radio swatches/pills) ─────────────────────────
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-sm-variant-input]');
      if (!input) return;
      var section = input.closest('.sm-pdp');
      if (!section) return;
      var variants = getVariantsData(section);
      if (!variants.length) return;

      var selected = [];
      section.querySelectorAll('.sm-pdp__opt').forEach(function (fs) {
        var checked = fs.querySelector('.sm-pdp__opt-input:checked');
        if (checked) selected.push(checked.value);
        var label = fs.querySelector('.sm-pdp__opt-selected');
        if (label && checked) label.textContent = checked.value;
      });

      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });
      applyVariantToUI(match);
    });

    // ── Sticky bar variant select ─────────────────────────────────────
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-sm-sticky-variant]');
      if (!sel) return;
      var section = getSection();
      if (!section) return;
      var variants = getVariantsData(section);
      var match = findVariantById(variants, sel.value);
      if (!match) return;

      // Sync radios in the main picker
      section.querySelectorAll('.sm-pdp__opt').forEach(function (fs, idx) {
        var optValue = match.options[idx];
        if (!optValue) return;
        var label = fs.querySelector('.sm-pdp__opt-selected');
        if (label) label.textContent = optValue;
        fs.querySelectorAll('.sm-pdp__opt-input').forEach(function (radio) {
          radio.checked = (radio.value === optValue);
        });
      });
      applyVariantToUI(match);
    });

    // ── AJAX add to cart ──────────────────────────────────────────────
    function setBtnLoading(btn, loading) {
      if (!btn) return;
      btn.classList.toggle('is-loading', !!loading);
      btn.disabled = !!loading;
    }

    function getAddPayload(opts) {
      opts = opts || {};
      var section = getSection();
      var idInput = section && section.querySelector('input[name="id"]');
      var qtyInput = section && section.querySelector('.sm-pdp__qty-input');
      return {
        id: idInput ? idInput.value : null,
        quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1
      };
    }

    // Main product + any checked bundle add-ons, as a /cart/add items array
    function getAddItems() {
      var main = getAddPayload();
      var items = [{ id: main.id, quantity: main.quantity }];
      var section = getSection();
      if (section) {
        section.querySelectorAll('[data-sm-addon]:checked').forEach(function (cb) {
          if (cb.value) items.push({ id: cb.value, quantity: 1 });
        });
      }
      return items;
    }

    function applyCartUpdate(data) {
      var cartDrawer = document.querySelector('cart-drawer');
      // Prefer Dawn's built-in renderContents — it re-binds overlay close + opens drawer
      if (cartDrawer && data && data.sections && typeof cartDrawer.renderContents === 'function') {
        try {
          cartDrawer.renderContents(data);
          return;
        } catch (e) {
          // fall through to manual path
        }
      }
      // Manual fallback: replace #CartDrawer innerHTML, re-bind overlay, open
      if (data && data.sections && data.sections['cart-drawer']) {
        var fragment = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        var newDrawer = fragment.querySelector('#CartDrawer');
        var currentDrawer = document.getElementById('CartDrawer');
        if (newDrawer && currentDrawer) currentDrawer.innerHTML = newDrawer.innerHTML;
      }
      var trigger = document.getElementById('cart-icon-bubble');
      if (trigger) trigger.click();
    }

    function showAddError(btn, message) {
      var lbl = btn && btn.querySelector('.sm-pdp__btn-label');
      if (lbl) {
        var prev = lbl.innerHTML;
        lbl.textContent = message || 'Try again';
        setTimeout(function () { lbl.innerHTML = prev; }, 2200);
      } else {
        alert(message || 'Could not add to cart. Please try again.');
      }
    }

    function addToCart(items, triggerBtn, opts) {
      opts = opts || {};
      // Accept either a single {id, quantity} payload or an array of items
      if (!Array.isArray(items)) items = [items];
      if (!items.length || !items[0] || !items[0].id) {
        showAddError(triggerBtn, 'Pick a variant');
        return Promise.reject(new Error('No variant'));
      }
      setBtnLoading(triggerBtn, true);

      var body = {
        items: items,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      };

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      // Ensure ".js" suffix so Shopify returns JSON
      if (!/\.js$/.test(addUrl)) addUrl = addUrl.replace(/\/$/, '') + '.js';

      return fetch(addUrl, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
        console.log("data", data);
          if (opts.checkout) {
            window.location.href = '/checkout';
            return;
          }
          applyCartUpdate(data);
        })
        .catch(function (err) {
          var msg = (err && (err.description || err.message)) || 'Could not add to cart';
          showAddError(triggerBtn, msg);
        })
        .finally(function () {
          if (!opts.checkout) setBtnLoading(triggerBtn, false);
        });
    }

    // Add-to-cart triggers (main + sticky)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-add-trigger]');
      if (!btn) return;
      e.preventDefault();
      addToCart(getAddItems(), btn);
    });

    // Buy-now triggers (main + sticky)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-buy-trigger]');
      if (!btn) return;
      e.preventDefault();
      addToCart(getAddItems(), btn, { checkout: true });
    });

    // Catch the form's native submit (e.g. Enter key in qty) and route through AJAX
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('.sm-pdp__form');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-sm-add-trigger]');
      addToCart(getAddItems(), btn);
    });

    // Add-on checkboxes — update the "N selected" count
    document.addEventListener('change', function (e) {
      if (!e.target.closest('[data-sm-addon]')) return;
      var box = e.target.closest('[data-sm-addons]');
      if (!box) return;
      var count = box.querySelectorAll('[data-sm-addon]:checked').length;
      var label = box.querySelector('[data-sm-addons-count]');
      if (label) label.textContent = count + ' selected';
    });

    // ── Pincode delivery check ────────────────────────────────────────
    var SM_PIN_OK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>';
    var SM_PIN_ERR = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>';

    // Allow digits only, cap at 6
    document.addEventListener('input', function (e) {
      var inp = e.target.closest('[data-sm-pin-input]');
      if (!inp) return;
      var clean = inp.value.replace(/\D/g, '').slice(0, 6);
      if (clean !== inp.value) inp.value = clean;
      var box = inp.closest('.sm-pdp__pincode');
      var res = box && box.querySelector('[data-sm-pin-result]');
      if (res && !res.hidden) { res.hidden = true; res.classList.remove('is-error'); }
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-pin-check]');
      if (!btn) return;
      var box = btn.closest('.sm-pdp__pincode');
      if (!box) return;
      var input = box.querySelector('[data-sm-pin-input]');
      var result = box.querySelector('[data-sm-pin-result]');
      if (!input || !result) return;

      var pin = (input.value || '').replace(/\D/g, '');

      if (!/^\d{6}$/.test(pin)) {
        result.hidden = false;
        result.classList.add('is-error');
        result.innerHTML = SM_PIN_ERR + '<span class="sm-pdp__pincode-result-txt"><strong>Please enter a valid 6-digit pincode</strong></span>';
        input.focus();
        return;
      }

      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      result.hidden = true;
      result.classList.remove('is-error');

      var delay = 1000 + Math.floor(Math.random() * 3000); // 1–4s loader
      setTimeout(function () {
        btn.classList.remove('is-loading');
        var by = new Date();
        by.setDate(by.getDate() + 5);
        var byTxt = by.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
        var note = box.getAttribute('data-sm-pin-success') || 'COD Available';
        result.hidden = false;
        result.classList.remove('is-error');
        result.innerHTML = SM_PIN_OK +
          '<span class="sm-pdp__pincode-result-txt">' +
            '<strong>' + pin + ' is serviceable</strong>' +
            '<span class="sm-pdp__pincode-result-sub">Get it by ' + byTxt + ' · ' + note + '</span>' +
          '</span>';
      }, delay);
    });

    // ── Coupon code copy ──────────────────────────────────────────────
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-copy]');
      if (!btn) return;
      var code = btn.getAttribute('data-sm-copy');
      if (!code) return;
      navigator.clipboard.writeText(code).then(function () {
        var prev = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.textContent = prev; }, 1400);
      });
    });

    // ── Free-gift tiers — re-evaluate on cart change ──────────────────
    function refreshGiftTiers() {
      var giftBox = document.querySelector('[data-sm-gifts]');
      if (!giftBox) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          giftBox.querySelectorAll('[data-sm-gift]').forEach(function (el) {
            var t = parseInt(el.getAttribute('data-threshold'), 10) || 0;
            var m = parseInt(el.getAttribute('data-min-items'), 10) || 1;
            var unlocked = cart.total_price >= t && cart.item_count >= m;
            el.classList.toggle('is-unlocked', unlocked);
          });
        })
        .catch(function () {});
    }
    document.addEventListener('cart:update', refreshGiftTiers);
    document.addEventListener('cart:updated', refreshGiftTiers);
    // Refresh after our own add-to-cart fires
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-sm-add-trigger], [data-sm-card-add]')) {
        setTimeout(refreshGiftTiers, 800);
      }
    });

    // ── Sticky cart visibility (desktop + mobile, after hero scrolls past) ─
    var stickyCart = document.querySelector('[data-sm-sticky-cart]');
    var hero = document.querySelector('.sm-pdp__hero');
    if (stickyCart && hero && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyCart.hidden = entry.isIntersecting;
        });
      }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
      io.observe(hero);
    }
  })();

  if (!customElements.get('sm-tabs')) {
    class SmTabs extends HTMLElement {
      connectedCallback() {
        this._pills = Array.from(this.querySelectorAll('[data-sm-tab]'));
        this._panels = Array.from(this.querySelectorAll('[data-sm-panel]'));
        this._pills.forEach((pill) => {
          pill.addEventListener('click', (e) => {
            e.preventDefault();
            this._activate(pill.dataset.smTab);
          });
        });
      }
      _activate(name) {
        this._pills.forEach((p) => {
          var on = p.dataset.smTab === name;
          p.classList.toggle('is-active', on);
          p.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this._panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.smPanel === name);
        });
      }
    }
    customElements.define('sm-tabs', SmTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-mobile-menu"]) return;
  try {
    
  (function () {
    if (window.__smMobileMenuBound) return;
    window.__smMobileMenuBound = true;

    const open = () => {
      document.body.classList.add('sm-menu-open');
      const panel = document.querySelector('[data-sm-mobile-menu] .sm-mmenu__panel');
      if (panel) {
        panel.setAttribute('aria-hidden', 'false');
        panel.focus();
      }
    };

    const close = () => {
      document.body.classList.remove('sm-menu-open');
      const panel = document.querySelector('[data-sm-mobile-menu] .sm-mmenu__panel');
      if (panel) panel.setAttribute('aria-hidden', 'true');
    };

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-sm-open-menu]')) {
        e.preventDefault();
        open();
      } else if (e.target.closest('[data-sm-close-menu]')) {
        e.preventDefault();
        close();
      } else if (e.target.closest('[data-sm-mobile-menu] .sm-mmenu__nav a')) {
        close();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && document.body.classList.contains('sm-menu-open')) {
        close();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.__smJrBound) return;
      root.__smJrBound = true;

      var token = root.getAttribute('data-token');
      var shop = root.getAttribute('data-shop');
      var handle = root.getAttribute('data-handle');
      var productId = root.getAttribute('data-product-id');
      var productTitle = root.getAttribute('data-product-title');
      var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 8;

      var listEl = root.querySelector('[data-sm-jr-list]');
      var moreBtn = root.querySelector('[data-sm-jr-more]');
      var avgEl = root.querySelector('[data-sm-jr-avg]');
      var countEl = root.querySelector('[data-sm-jr-count]');
      var barsEl = root.querySelector('[data-sm-jr-bars]');
      var page = 1;
      var totalShown = 0;
      var totalCount = 0;

      function stars(n) {
        var s = '';
        for (var i = 1; i <= 5; i++) s += '<span class="' + (i <= n ? '' : 'off') + '">★</span>';
        return s;
      }
      function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
      function initials(name) {
        var p = (name || 'A').trim().split(/\s+/).filter(Boolean);
        var f = (p[0] || 'A').charAt(0);
        var l = p.length > 1 ? p[p.length - 1].charAt(0) : '';
        return (f + l).toUpperCase();
      }
      function fmtDate(raw) {
        if (!raw) return '';
        var d = new Date(raw.replace(' UTC', 'Z').replace(' ', 'T'));
        if (isNaN(d)) return '';
        return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
      }

      function parseWidget(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var w = doc.querySelector('.jdgm-rev-widg');
        var out = { avg: w ? w.getAttribute('data-average-rating') : '0', count: w ? parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0 : 0, hist: {}, revs: [] };
        doc.querySelectorAll('.jdgm-histogram__row').forEach(function (row) {
          out.hist[row.getAttribute('data-rating')] = { freq: parseInt(row.getAttribute('data-frequency'), 10) || 0, pct: parseInt(row.getAttribute('data-percentage'), 10) || 0 };
        });
        doc.querySelectorAll('.jdgm-rev').forEach(function (el) {
          var rEl = el.querySelector('.jdgm-rev__rating');
          var ts = el.querySelector('.jdgm-rev__timestamp');
          var pics = [];
          el.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link, .jdgm-rev__pics a').forEach(function (a) {
            var full = a.getAttribute('href') || a.getAttribute('data-mfp-src');
            var im = a.querySelector('img');
            var thumb = im ? (im.getAttribute('data-src') || im.getAttribute('src')) : null;
            if (full || thumb) pics.push({ full: full || thumb, thumb: thumb || full });
          });
          if (!pics.length) {
            el.querySelectorAll('.jdgm-rev__pics img, .jdgm-rev__pic-img').forEach(function (img) {
              var src = img.getAttribute('data-src') || img.getAttribute('src');
              if (src) pics.push({ full: src, thumb: src });
            });
          }
          out.revs.push({
            rating: rEl ? parseInt(rEl.getAttribute('data-score'), 10) || 0 : 0,
            author: ((el.querySelector('.jdgm-rev__author') || {}).textContent || 'Anonymous').trim(),
            verified: el.getAttribute('data-verified-buyer') === 'true',
            title: ((el.querySelector('.jdgm-rev__title') || {}).textContent || '').trim(),
            body: ((el.querySelector('.jdgm-rev__body') || {}).textContent || '').trim(),
            date: ts ? (ts.getAttribute('data-content') || '') : '',
            pics: pics
          });
        });
        return out;
      }

      function renderSummary(data) {
        if (avgEl) avgEl.textContent = parseFloat(data.avg || 0).toFixed(1);
        if (countEl) countEl.textContent = data.count;
        totalCount = data.count;
        if (barsEl) {
          var html = '';
          for (var r = 5; r >= 1; r--) {
            var row = data.hist[r] || { freq: 0, pct: 0 };
            html += '<div class="sm-jr__bar"><span class="sm-jr__bar-stars">' + r + ' ★</span>' +
              '<span class="sm-jr__bar-track"><span class="sm-jr__bar-fill" data-pct="' + row.pct + '"></span></span>' +
              '<span class="sm-jr__bar-count">' + row.freq + '</span></div>';
          }
          barsEl.innerHTML = html;
          requestAnimationFrame(function () {
            barsEl.querySelectorAll('.sm-jr__bar-fill').forEach(function (f) { f.style.width = (f.getAttribute('data-pct') || 0) + '%'; });
          });
        }
      }

      function picsHTML(rv) {
        var arr = rv.pics || [];
        if (!arr.length) return '';
        var gal = JSON.stringify(arr.map(function (p) { return p.full; })).replace(/"/g, '&quot;');
        var meta = JSON.stringify({ name: rv.author, date: rv.date, rating: rv.rating, verified: rv.verified, body: rv.body }).replace(/"/g, '&quot;');
        var max = 4, shown = arr.slice(0, max), extra = arr.length - max;
        var thumbs = shown.map(function (p, i) {
          var more = (i === max - 1 && extra > 0) ? '<span class="sm-jr__card-pic-more">+' + extra + '</span>' : '';
          return '<button type="button" class="sm-jr__card-pic" data-sm-rev-pic data-index="' + i + '" aria-label="View review photo"><img src="' + p.thumb + '" alt="" loading="lazy">' + more + '</button>';
        }).join('');
        return '<div class="sm-jr__card-pics" data-sm-rev-gallery="' + gal + '" data-sm-rev-meta="' + meta + '">' + thumbs + '</div>';
      }
      function cardHTML(rv) {
        var initial = initials(rv.author);
        var verified = rv.verified ? '<span class="sm-jr__verified"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>Verified Buyer</span>' : '';
        var title = rv.title ? '<p class="sm-jr__card-title">' + esc(rv.title) + '</p>' : '';
        return '<article class="sm-jr__card">' +
          '<div class="sm-jr__card-foot"><span class="sm-jr__card-avatar">' + esc(initial) + '</span>' +
          '<span class="sm-jr__card-meta"><span class="sm-jr__card-author">' + esc(rv.author) + '</span>' +
          (rv.date ? '<span class="sm-jr__card-date">' + fmtDate(rv.date) + '</span>' : '') + '</span>' + verified + '</div>' +
          '<div class="sm-jr__card-top"><span class="sm-jr__stars">' + stars(rv.rating) + '</span></div>' +
          title +
          '<p class="sm-jr__card-body">' + esc(rv.body) + '</p>' + picsHTML(rv) +
          '</article>';
      }

      function load(append) {
        var url = 'https://judge.me/api/v1/widgets/product_review?api_token=' + encodeURIComponent(token) +
          '&shop_domain=' + encodeURIComponent(shop) + '&platform=shopify&handle=' + encodeURIComponent(handle) +
          '&per_page=' + perPage + '&page=' + page;
        if (moreBtn) moreBtn.classList.toggle('is-loading', append);
        return fetch(url, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var data = parseWidget(d.widget || '');
            if (!append) { renderSummary(data); listEl.innerHTML = ''; }
            if (!data.revs.length && !append) {
              listEl.innerHTML = '<div class="sm-jr__empty">No reviews yet — be the first to review this product!</div>';
            }
            data.revs.forEach(function (rv, i) {
              var div = document.createElement('div');
              div.innerHTML = cardHTML(rv);
              var card = div.firstChild;
              card.style.animationDelay = (i * 0.05) + 's';
              listEl.appendChild(card);
            });
            totalShown += data.revs.length;
            if (moreBtn) {
              moreBtn.classList.remove('is-loading');
              moreBtn.hidden = totalShown >= totalCount || data.revs.length === 0;
            }
          })
          .catch(function () {
            if (!append) listEl.innerHTML = '<div class="sm-jr__empty">Couldn’t load reviews right now.</div>';
            if (moreBtn) moreBtn.classList.remove('is-loading');
          });
      }

      load(false);
      if (moreBtn) moreBtn.addEventListener('click', function () { page += 1; load(true); });

      /* ── Modal ── */
      var modal = root.querySelector('[data-sm-jr-modal]');
      var form = root.querySelector('[data-sm-jr-form]');
      var steps = Array.prototype.slice.call(form.querySelectorAll('.sm-jr-step'));
      var dots = root.querySelector('[data-sm-jr-dots]');
      var nextBtn = root.querySelector('[data-sm-jr-next]');
      var backBtn = root.querySelector('[data-sm-jr-back]');
      var footer = root.querySelector('[data-sm-jr-footer]');
      var errEl = root.querySelector('[data-sm-jr-err]');
      var current = 1;
      var rating = 0;

      function showStep(n) {
        current = n;
        steps.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-sm-jr-step') === String(n)); });
        if (dots) Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i < n); });
        if (n === 'done') { footer.hidden = true; return; }
        footer.hidden = false;
        backBtn.hidden = n === 1;
        nextBtn.textContent = n === 3 ? 'Submit review' : 'Next';
        validate();
      }
      function validate() {
        var ok = true;
        if (current === 1) ok = rating > 0;
        if (current === 2) ok = (root.querySelector('[data-sm-jr-body]').value.trim().length > 0);
        if (current === 3) {
          var nm = root.querySelector('[data-sm-jr-name]').value.trim();
          var em = root.querySelector('[data-sm-jr-email]').value.trim();
          ok = nm.length > 0 && /.+@.+\..+/.test(em);
        }
        nextBtn.disabled = !ok;
      }
      function openModal() { modal.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      function closeModal() { modal.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

      root.querySelectorAll('[data-sm-jr-open]').forEach(function (b) { b.addEventListener('click', openModal); });
      root.querySelectorAll('[data-sm-jr-close]').forEach(function (b) { b.addEventListener('click', closeModal); });

      root.querySelectorAll('[data-sm-jr-star]').forEach(function (st) {
        st.addEventListener('click', function () {
          rating = parseInt(st.getAttribute('data-sm-jr-star'), 10);
          root.querySelectorAll('[data-sm-jr-star]').forEach(function (s2) {
            s2.classList.toggle('is-on', parseInt(s2.getAttribute('data-sm-jr-star'), 10) <= rating);
          });
          validate();
        });
      });
      ['[data-sm-jr-body]', '[data-sm-jr-name]', '[data-sm-jr-email]'].forEach(function (sel) {
        var el = root.querySelector(sel); if (el) el.addEventListener('input', validate);
      });

      backBtn.addEventListener('click', function () { if (current > 1) showStep(current - 1); });
      nextBtn.addEventListener('click', function () {
        if (nextBtn.disabled) return;
        if (current < 3) { showStep(current + 1); return; }
        submit();
      });

      function submit() {
        nextBtn.disabled = true; nextBtn.textContent = 'Submitting…'; errEl.hidden = true;
        var body = new URLSearchParams();
        body.set('api_token', token);
        body.set('shop_domain', shop);
        body.set('platform', 'shopify');
        body.set('id', productId);
        body.set('name', root.querySelector('[data-sm-jr-name]').value.trim());
        body.set('email', root.querySelector('[data-sm-jr-email]').value.trim());
        body.set('rating', rating);
        body.set('title', root.querySelector('[data-sm-jr-revtitle]').value.trim());
        body.set('body', root.querySelector('[data-sm-jr-body]').value.trim());
        fetch('https://judge.me/api/v1/reviews', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
          body: body.toString()
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (res.ok || (res.j && (res.j.id || res.j.review))) { showStep('done'); }
            else { throw new Error((res.j && (res.j.error || res.j.message)) || 'Submit failed'); }
          })
          .catch(function (e) {
            errEl.hidden = false; errEl.textContent = e.message || 'Could not submit. Please try again.';
            nextBtn.disabled = false; nextBtn.textContent = 'Submit review';
          });
      }

      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') closeModal(); });
    }

    document.querySelectorAll('[data-sm-reviews]').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-sm-reviews]') || (e.target.matches && e.target.matches('[data-sm-reviews]') ? e.target : null);
      if (el) init(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__smRevBound) return;
    window.__smRevBound = true;

    function updateArrows(track) {
      var wrap = track.closest('.sm-rev__carousel-wrap');
      if (!wrap) return;
      var prev = wrap.querySelector('[data-sm-rev-scroll="-1"]');
      var next = wrap.querySelector('[data-sm-rev-scroll="1"]');
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      var noOverflow = track.scrollWidth <= track.clientWidth + 4;
      if (prev) prev.hidden = atStart || noOverflow;
      if (next) next.hidden = atEnd || noOverflow;
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-rev-scroll]');
      if (!btn) return;
      var wrap = btn.closest('.sm-rev__carousel-wrap');
      if (!wrap) return;
      var track = wrap.querySelector('[data-sm-rev-track]');
      if (!track) return;
      var dir = parseInt(btn.getAttribute('data-sm-rev-scroll'), 10) || 1;
      var firstCard = track.querySelector('.sm-rev__card');
      var step = firstCard ? (firstCard.offsetWidth + 18) : 320;
      track.scrollBy({ left: dir * step, behavior: 'smooth' });
    });

    document.querySelectorAll('[data-sm-rev-track]').forEach(function (track) {
      updateArrows(track);
      track.addEventListener('scroll', function () { updateArrows(track); });
    });
    window.addEventListener('resize', function () {
      document.querySelectorAll('[data-sm-rev-track]').forEach(updateArrows);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-wishlist-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__smWishlistPageBound) return;
    window.__smWishlistPageBound = true;

    var section = document.querySelector('.sm-wishpg');
    if (!section) return;
    var grid = section.querySelector('[data-sm-wish-grid]');
    var clearBtn = section.querySelector('[data-sm-wish-clear]');
    var pluralEl = section.querySelector('[data-sm-wish-plural]');

    function fmtMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      var fmt = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'INR';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: fmt }).format(amount); }
      catch (e) { return '₹' + amount; }
    }
    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function renderCard(p) {
      var hasSale = p.compare_at_price && p.compare_at_price > p.price;
      var img = p.image
        ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="240" height="240">'
        : '';
      var addBtnAttrs, addBtnLabel;
      if (p.has_only_default_variant && p.variant_id) {
        addBtnAttrs = 'data-sm-wcard-add data-id="' + p.id + '" data-variant-id="' + p.variant_id + '"';
        addBtnLabel = 'Add to Cart';
      } else {
        // Multi-variant — reuse the global Quick View modal trigger
        addBtnAttrs = 'data-sm-card-quickview data-sm-handle="' + escapeHtml(p.handle) + '" data-sm-url="' + escapeHtml(p.url) + '"';
        addBtnLabel = 'Quick View';
      }
      return '' +
      '<article class="sm-wcard" data-card-id="' + p.id + '">' +
        '<button type="button" class="sm-wcard__remove" data-sm-wcard-remove data-id="' + p.id + '" aria-label="Remove from wishlist">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<a href="' + escapeHtml(p.url) + '" class="sm-wcard__image" aria-label="' + escapeHtml(p.title) + '">' + img + '</a>' +
        '<div class="sm-wcard__body">' +
          (p.vendor ? '<div class="sm-wcard__brand">' + escapeHtml(p.vendor) + '</div>' : '') +
          '<a href="' + escapeHtml(p.url) + '" class="sm-wcard__title">' + escapeHtml(p.title) + '</a>' +
          '<div class="sm-wcard__price-row">' +
            '<span class="sm-wcard__price">' + fmtMoney(p.price) + '</span>' +
            (hasSale ? '<span class="sm-wcard__mrp">' + fmtMoney(p.compare_at_price) + '</span>' : '') +
          '</div>' +
        '</div>' +
        '<div class="sm-wcard__actions">' +
          '<a href="' + escapeHtml(p.url) + '" class="sm-wcard__btn sm-wcard__btn--ghost"><span>View</span></a>' +
          '<button type="button" class="sm-wcard__btn sm-wcard__btn--solid" ' + addBtnAttrs + '><span>' + addBtnLabel + '</span></button>' +
        '</div>' +
      '</article>';
    }

    function readWishlist() {
      if (window.smWishlist) return window.smWishlist.list();
      try {
        var raw = localStorage.getItem('sm_wishlist');
        var arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr : [];
      } catch (e) { return []; }
    }

    function render() {
      var items = readWishlist();
      grid.innerHTML = items.map(renderCard).join('');
      // Mirror empty toggle in case the global manager hasn't run yet
      section.classList.toggle('is-empty', items.length === 0);
      if (clearBtn) clearBtn.hidden = items.length === 0;
      if (pluralEl) pluralEl.textContent = items.length === 1 ? '' : 's';
      // Sync count display in this section
      section.querySelectorAll('[data-sm-wish-count]').forEach(function (el) {
        el.textContent = items.length;
      });
    }

    document.addEventListener('sm:wishlist:change', render);

    // Remove individual card
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-wcard-remove]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-id');
      if (window.smWishlist) window.smWishlist.remove(id);
    });

    // Clear all
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (!window.smWishlist) return;
        if (confirm('Remove all items from your wishlist?')) {
          window.smWishlist.clear();
        }
      });
    }

    // AJAX add → remove from wishlist + open cart drawer
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-wcard-add]');
      if (!btn) return;
      e.preventDefault();
      var id = btn.getAttribute('data-id');
      var variantId = btn.getAttribute('data-variant-id');
      btn.classList.add('is-loading');
      btn.disabled = true;
      if (typeof window.smAddToCart === 'function') {
        window.smAddToCart(variantId, 1, btn, {
          afterAdd: function () {
            if (window.smWishlist) window.smWishlist.remove(id);
            btn.classList.remove('is-loading');
            btn.disabled = false;
          }
        });
      } else {
        // Fallback — POST directly
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', 1);
        fetch('/cart/add.js', { method: 'POST', body: fd })
          .then(function () {
            if (window.smWishlist) window.smWishlist.remove(id);
            window.location.href = '/cart';
          });
      }
    });

    render();
  })();

  } catch(e) { console.error(e); }
})();
})();
